import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, IconButton } from '@mui/material';
// utils
import { bgBlur } from 'utils/cssStyles';
// components
import Iconify from 'components/iconify';

// ----------------------------------------------------------------------

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 0;

const StyledRoot = styled(AppBar)(({ theme }) => ({
    ...bgBlur({ color: theme.palette.background.paper }),
    boxShadow: 'none'
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        width: 0
    }
}));

// ----------------------------------------------------------------------

Header.propTypes = {
    onOpenNav: PropTypes.func
};

export default function Header({ onOpenNav }) {

    return (
        <StyledRoot>
            <StyledToolbar>
                <IconButton
                    onClick={onOpenNav}
                    sx={{
                        mr: 1,
                        color: 'text.primary',

                        display: { lg: 'none' }
                    }}
                >
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
                {/*<Logo />*/}

            </StyledToolbar>
        </StyledRoot>
    );
}
